import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { Row, Col, Card, CardBody, Input, Label, Spinner, Alert } from 'reactstrap';

import { connect } from 'react-redux';

import {
  getExtraCustomerChoiceData,
  updateExtraCustomerChoiceData,
  toggleExtraCustomerChoiceData,
} from '../../../../actions/company';

import { 
  getCustomVouchersCommission
} from '../../../../actions/admin';

import Toggle from '../../../components/Toggle/Toggle';

const pound = `${'\u00A3'}`;

class ExtraCustomerChoice extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    categories: PropTypes.shape(),
    company: PropTypes.shape(),
    updateCompanyValue: PropTypes.func.isRequired,
    updateLogo: PropTypes.func.isRequired,
    updatePrimaryVoucherImage: PropTypes.func.isRequired,
    updateVoucherImages: PropTypes.func.isRequired,
    getExtraCustomerChoice: PropTypes.func.isRequired,
    toggleExtraCustomerChoice: PropTypes.func.isRequired,
    saveData: PropTypes.func.isRequired,
    fetchCustomVouchersCommission: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    categories: {},
    company: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      companyLogo: null,
      companyPrimaryVoucherImage: null,
      existingVoucherImages: [],
      deletedExistingImages: [],
      changes: {},
      showNoPermission: false,
      categoriesOrdered: [],

      enabled: null,
      autoAcceptFaceValueMin: 5,
      autoAcceptFaceValueMax: 500,
      autoAcceptDiscountMin: 0,
      autoAcceptDiscountMax: 95,
    };
  }

  componentDidMount() {
    const { user, isLoggedIn, history, adminViewAsCompany, getExtraCustomerChoice, fetchCustomVouchersCommission } = this.props;

    fetchCustomVouchersCommission().then((res) => {
      const { customVouchersCommissionSetting } = this.props;

      this.setState({ customVouchersCommission: customVouchersCommissionSetting });
    });

    if (adminViewAsCompany) {
      this.setState({ showNoPermission: false });

      getExtraCustomerChoice(adminViewAsCompany).then((res) => {
        console.log('getExtraCustomerChoice res', res);

          this.setState({
            enabled: (res && res.enabled) || null,
            maxOfferCount: (res && res.maxOfferCount) || null,
            autoAcceptFaceValueMin: (res && res.autoAcceptFaceValueMin) || 5,
            autoAcceptFaceValueMax: (res && res.autoAcceptFaceValueMax) || 500,
            autoAcceptDiscountMin: (res && res.autoAcceptDiscountMin) || 0,
            autoAcceptDiscountMax: (res && res.autoAcceptDiscountMax) || 95,
          });
      });
    } else if (user && Object.keys(user).length > 0) {

      if (!user || !isLoggedIn || !user.company) {
        history.push('/');
      } else {
        getExtraCustomerChoice(user.company).then((res) => {
          console.log('getExtraCustomerChoice res', res);

          this.setState({
            enabled: (res && res.enabled) || null,
            maxOfferCount: (res && res.maxOfferCount) || null,
            autoAcceptFaceValueMin: (res && res.autoAcceptFaceValueMin) || 5,
            autoAcceptFaceValueMax: (res && res.autoAcceptFaceValueMax) || 500,
            autoAcceptDiscountMin: (res && res.autoAcceptDiscountMin) || 0,
            autoAcceptDiscountMax: (res && res.autoAcceptDiscountMax) || 95,
          });
        });

        if (user.role === 'teamOwner') {
          this.setState({ showNoPermission: false });
        } else {
          const { roles } = this.props;

          if (roles && roles[user.role] && roles[user.role].permissions && roles[user.role].permissions.manageCompany) {
            this.setState({ showNoPermission: false });
          } else {
            this.setState({ showNoPermission: true });
          }
        }
      }
    } else {
      history.push('/');
    }
  }


  handleChange = async (e) => {
    const {
      maxOfferCount,
      autoAcceptFaceValueMin,
      autoAcceptFaceValueMax,
      autoAcceptDiscountMin,
      autoAcceptDiscountMax,
    } = this.state;

    if (e.target && e.target.name) {
      const { name, value } = e.target;

      console.log('handleChange', name, value);

      if (name) {
        if ((name === 'autoAcceptFaceValueMin' || name === 'autoAcceptFaceValueMax') && (value < 5)) {
          this.setState({
            error: `Cannot be less than £5`,
            [name]: parseInt(value, 10) || null,
          });
        } else if ((name === 'autoAcceptFaceValueMin' || name === 'autoAcceptFaceValueMax') && (value > 500)) {
          this.setState({
            error: `Cannot be more than £500`,
            [name]: parseInt(value, 10) || null,
          });
        } else if ((name === 'autoAcceptDiscountMin' || name === 'autoAcceptDiscountMax') && (value < 0)) {
          this.setState({
            error: `Cannot be less than 0%`,
            [name]: parseInt(value, 10) || null,
          });
        } else if ((name === 'autoAcceptDiscountMin' || name === 'autoAcceptDiscountMax') && (value > 95)) {
          this.setState({
            error: `Cannot be more than 95%`,
            [name]: parseInt(value, 10) || null,
          });
        } else if (name === 'autoAcceptFaceValueMin' && (value > autoAcceptFaceValueMax)) {
          this.setState({
            error: `Must be lower than second threshold`,
            [name]: parseInt(value, 10) || null,
          });
        } else if (name === 'autoAcceptFaceValueMax' && (value < autoAcceptFaceValueMin)) {
          this.setState({
            error: `Must be higher than first threshold`,
            [name]: parseInt(value, 10) || null,
          });
        } else if (name === 'autoAcceptDiscountMin' && (value > autoAcceptDiscountMax)) {
          this.setState({
            error: `Must be lower than second threshold`,
            [name]: parseInt(value, 10) || null,
          });
        } else if (name === 'autoAcceptDiscountMax' && (value < autoAcceptDiscountMin)) {
          this.setState({
            error: `Must be higher than first threshold`,
            [name]: parseInt(value, 10) || null,
          });
        } else if (name === 'maxOfferCount' && (value < 0)) {
          this.setState({
            error: `Offers must be larger than 0`,
            [name]: parseInt(value, 10)  ? parseInt(value, 10) : null,
          });
        } else {
          let tempData = {
            maxOfferCount,
            autoAcceptFaceValueMin,
            autoAcceptFaceValueMax,
            autoAcceptDiscountMin,
            autoAcceptDiscountMax,
          };

          tempData[name] = parseInt(value, 10);

          if (tempData.autoAcceptFaceValueMin >= 5 && tempData.autoAcceptFaceValueMin <= 500 && tempData.autoAcceptFaceValueMax >= 5 && tempData.autoAcceptFaceValueMax <= 500
            && tempData.autoAcceptDiscountMin >= 0 && tempData.autoAcceptDiscountMin <= 95 && tempData.autoAcceptDiscountMax >= 0 && tempData.autoAcceptDiscountMax <= 95 && (tempData.maxOfferCount >= 0 || !tempData.maxOfferCount)) {
            await this.setState({
              [name]: parseInt(value, 10) || null,
              error: null,
            });

            this.saveData();
          } else {
            await this.setState({
              [name]: parseInt(value, 10) || null,
            });
          }
        }
      }
    }
  };

  saveData = () => {
    const { saveData, adminViewAsCompany, user } = this.props;
    const {
      maxOfferCount,
      autoAcceptFaceValueMin,
      autoAcceptFaceValueMax,
      autoAcceptDiscountMin,
      autoAcceptDiscountMax,
    } = this.state;

    if (adminViewAsCompany) {
      saveData(adminViewAsCompany, { maxOfferCount, autoAcceptFaceValueMin, autoAcceptFaceValueMax, autoAcceptDiscountMin, autoAcceptDiscountMax });
    } else {
      saveData(user.company, { maxOfferCount, autoAcceptFaceValueMin, autoAcceptFaceValueMax, autoAcceptDiscountMin, autoAcceptDiscountMax });
    }
  }

  toggleExtraCustomerChoice = () => {
    const { toggleExtraCustomerChoice, adminViewAsCompany, user } = this.props;
    const {
      enabled,
    } = this.state;

    this.setState({ enabled: !enabled });

    if (adminViewAsCompany) {
      toggleExtraCustomerChoice(adminViewAsCompany, !enabled);
    } else {
      toggleExtraCustomerChoice(user.company, !enabled);
    }
  }

  render() {
    const { showNoPermission } = this.props;
    const {
      enabled,
      maxOfferCount,
      autoAcceptFaceValueMin,
      autoAcceptFaceValueMax,
      autoAcceptDiscountMin,
      autoAcceptDiscountMax,
      error,
      customVouchersCommission,
    } = this.state;

    console.log('customVouchersCommission', customVouchersCommission);

    return (
      <div>
        <Card style={{ borderRadius: 20 }}>
          <CardBody style={{ paddingTop: 11 }}>
            <div className="basic-information" style={{ padding: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 }}>
              <div className="basic-information-row">
                <Label style={{ fontWeight: 700, color: "#000", display: 'inline-block', whiteSpace: 'nowrap', paddingRight: '0.6rem', fontSize: 15 }}>Extra Customer Choice</Label>
                <Toggle checked={enabled} onChange={this.toggleExtraCustomerChoice} />

                <div style={{ display: 'inline-block', float: 'right', width: '100%' }}>
                  <span style={{ color: "#00aeff", float: 'right', textAlign: 'right', display: 'inline-block', fontSize: '0.7rem', paddingLeft: 10 }}>You have 24 hours to respond to any requests that are not automatically accepted</span>
                </div>
                </div>
              <div className="basic-information-row" style={{ marginBottom: 15, fontSize: 14 }}>
                Let customers request one-off, custom face values and discounts within your campaigns. You will receive an email notification to review any requests not automatically accepted.
              </div>
              <div className="basic-information-row">
                {(!!error) && <Alert color="danger">{error}</Alert>}
              </div>
              <div className="basic-information-row" style={{ marginBottom: 12 }}>
                <div style={{ display: 'inline-block', fontSize: 14 }}>
                  <b>Offers:</b> maximum number you can receive
                </div>
                <div style={{ display: 'inline-block', fontSize: 14 }}>
                  <Input
                    name="maxOfferCount"
                    type="number"
                    value={maxOfferCount}
                    placeholder={`∞`}
                    style={{ width: 70 }}
                    className="basic-information-number-input"
                    onChange={this.handleChange}
                  />
                </div>
                <div style={{ display: 'inline-block', fontSize: 14 }}>
                per day
                </div>
              </div>

              <div className="basic-information-row" style={{ marginBottom: 12 }}>
                <div style={{ display: 'inline-block', fontSize: 14 }}>
                  <b>Face values:</b> Auto-accept if between
                </div>
                <div style={{ display: 'inline-block', fontSize: 14 }}>
                  <Input
                    name="autoAcceptFaceValueMin"
                    type="number"
                    // value={autoAcceptFaceValueMin}
                    value={autoAcceptFaceValueMin}
                    placeholder={`${pound}5`}
                    className="basic-information-number-input"
                    onChange={this.handleChange}
                  />
                </div>
                <div style={{ display: 'inline-block', fontSize: 14 }}>
                  and 
                </div>
                <div style={{ display: 'inline-block', fontSize: 14 }}>
                  <Input
                    name="autoAcceptFaceValueMax"
                    type="number"
                    value={autoAcceptFaceValueMax}
                    placeholder={`${pound}500`}
                    className="basic-information-number-input"
                    onChange={this.handleChange}
                  />
                </div>
              </div>


              <div className="basic-information-row" style={{ marginBottom: 12 }}>
                    <div style={{ display: 'inline-block', fontSize: 14 }}>
                      <b>Discounts:</b> Auto-accept if between
                    </div>
                    <div style={{ display: 'inline-block', fontSize: 14 }}>
                      <Input
                        name="autoAcceptDiscountMin"
                        type="number"
                        value={autoAcceptDiscountMin}
                        placeholder={`0%`}
                        className="basic-information-number-input"
                        onChange={this.handleChange}
                      />
                    </div>
                    <div style={{ display: 'inline-block', fontSize: 14 }}>
                      and
                    </div>
                    <div style={{ display: 'inline-block', fontSize: 14 }}>
                      <Input
                        name="autoAcceptDiscountMax"
                        type="number"
                        value={autoAcceptDiscountMax}
                        placeholder={`50%`}
                        className="basic-information-number-input"
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="basic-information-row" style={{ position: 'absolute', bottom: -5, right: 15, marginBottom: 15, fontSize: 10, textAlign: 'right', color: "#7f8fa4", float: 'right' }}>
                  {`Steppr charges a commission of ${(customVouchersCommission) ? customVouchersCommission : 10}% of voucher payment`}
                    </div>
              </div>


            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  company: state.company.company || {},
  isLoggedIn: state.user.isLoggedIn || false,
  adminViewAsCompany: state.admin.adminViewAsCompany || null,
  roles: state.users.companiesRoles || {},
  customVouchersCommissionSetting: state.admin.customVouchersCommissionSetting || null,
});

const mapDispatchToProps = {
  getExtraCustomerChoice: getExtraCustomerChoiceData,
  saveData: updateExtraCustomerChoiceData,
  toggleExtraCustomerChoice: toggleExtraCustomerChoiceData,
  fetchCustomVouchersCommission: getCustomVouchersCommission,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExtraCustomerChoice));
